import Legal from "@/views/Legal";
import Main from "@/views/Main";

export default [
  { path: '/legal', component: Legal },
  { path: '/:lang', component: Main },
  { path: '*', redirect: '/en' }
]
